<template>
	<div class="story_list_container">
	
	<card-generic
	title="<a href='https://www.dayton.com/' target='_blank'>&gt; More from Dayton.com</a>"
	title_class="orange"
	v-if="list_data"
	>
		
		<div class="row">
			<div class="col-6"
			v-for="(item, index) in list_data.list_items"
			:key="`list_${index}`"
			>
				
				<story-list-item
				v-bind="item"
				></story-list-item>

			</div>
		</div>

	</card-generic>

	</div>
</template>

<script>
import CardGeneric from '@/components/cards/card_generic';
import StoryListItem from './story_list_item'

export default {
	name: 'story_list',
	props: [
		'cms_list_id'
	],
	data () {
		return {
			
		}
	},
	computed: {
		item_limit: function() {
			let vm = this;
			let limit = 2;

			switch(this.$mq) {
			case 'mobile':
				limit = 4;
				break;

			case 'tablet':
			case 'laptop':
			case 'desktop':
				limit = 4;
				break;
			}

			return limit;
		},

		list_data: function() {
			let data = this.$root.store.lists.get_cms_list2(this.cms_list_id, this.item_limit);
			// console.log('data: ', data);
			return data;
		},
	},
	methods: {
		
	},
	components: {
		CardGeneric,
		StoryListItem,
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/lists/story_list.vue